// extracted by mini-css-extract-plugin
module.exports = {"tab":"TabButton_tab__1NJu4","tab-active":"TabButton_tab-active__3EQVn","tab-active-active":"TabButton_tab-active-active__11LT2"};